import { render } from "./OwnerConfirmationStep.vue?vue&type=template&id=5054b1c6"
import script from "./OwnerConfirmationStep.vue?vue&type=script&lang=js"
export * from "./OwnerConfirmationStep.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/estate-boost-frontend/estate-boost-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__